<template>
  <div class="bg-gray-900 rounded-lg p-2">
    <div class="flex justify-center">
      <LoadingSpinner class="h-10 w-10 text-yellow-500/80 my-8" v-if="loading" />
      <apexchart
        class="mt-4"
        height="400"
        type="bar"
        :options="options"
        :series="series"
        v-else-if="this.series.length"
        @dataPointSelection="clickHandler"
      ></apexchart>
      <h6 class="my-8 text-gray-600" v-else>بدون داده</h6>
    </div>
  </div>
</template>

<script>
import { getNewFoodTypeReport } from "../../API/API";
import LoadingSpinner from "../General/LoadingSpinner";

export default {
  name: "FoodTypeChart",
  components: { LoadingSpinner },
  props: ["month", "day"],
  data() {
    return {
      loading: true,
      isShow: false,
      options: {
        fontFamily: "iransans",
        colors: [
          "#ef4444",
          "#fb923c",
          "#9C27B0",
          "#3b82f6",
          "#22c55e",
          "#a855f7",
          "#ec4899",
          "#eab308",
        ],
        dataLabels: {
          enabled: true,
          formatter: (value) => {
            return this.$helper.numberShortener(value);
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: false,
          },
        },
        chart: {
          toolbar: {
            show: false,
          },
          events: {
            dataPointSelection: (event, chartContext, config) => {
              let id1 =
                this.series[config.seriesIndex].ids[config.dataPointIndex];
              console.log(id1);
              this.$router.push({
                path: "/management/chart2/food",
                query: { foodId1: id1, month: this.month },
              });
            },
          },
        },
        tooltip: {
          theme: "dark",
          y: {
            formatter: (value) => {
              return this.$helper.numberShortener(value);
            },
          },
        },
        xaxis: {
          categories: [],
          tickPlacement: "on",
          labels: {
            style: {
              colors: "#fff",
            },
          },
        },
        yaxis: [
          {
            labels: {
              style: {
                colors: "#d1d5db",
              },
            },
          },
        ],
        grid: {
          borderColor: "#d1d5db",
        },
        legend: {
          position: "top",
          labels: {
            colors: "#fff",
          },
        },
      },
      series: [],
    };
  },
  created() {
    this.getReport();
  },
  methods: {
    getReport() {
      this.loading = true;
      this.series = [];
      getNewFoodTypeReport(
        "day",
        "qty",
        "",
        "",
        "",
        "",
        this.month,
        this.day
      ).then((resp) => this.setChartData(resp));
    },
    setChartData(resp) {
      this.options = { ...this.options, xaxis: { categories: resp.data.result.xaxis, },};
      this.series = resp.data.result.yaxis;
      this.loading = false;
      if (this.series.length === 0) {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
    },
    clickHandler(event, chartContext, config) {
      let id1 = this.series[config.seriesIndex].ids[config.dataPointIndex];
      this.$router.push({
        path: "/management/chart2/food",
        query: { foodId1: id1, month: this.month },
      });
    },
  },
  watch: {
    day() {
      if (this.day !== "") this.getReport();
    },
    month() {
      this.getReport();
    },
  },
};
</script>

<style scoped></style>
